/* eslint-disable camelcase */
import BuilderConstructorGridV1_1 from './BuilderConstructorGridV1_1';

export default BuilderConstructorGridV1_1;
